import React, { useState, useEffect, memo } from 'react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import { errorExplinationMark, graduationCap, teacherVerifiedIcon, verifiedPic } from '../Icons';
import { useNotification } from '../Notifications/NotificationProvider';
export const version = "v1.0.0";
export const BackdropPitchBlack = () => {
    return <div className="backdropPitchBlack"></div>;
};
export const Backdrop = () => {
    return <div className="backdrop"></div>;
};
export let strings = ["Hello", "Hey", "Hi", "Saa", "Ahoy", "Top o' the mornin"];
export let motives = [
    "Keep pushing forward, hard work will pay off",
    "Embrace your heritage with pride",
    "Savor the journey, appreciate every moment",
    "Tackle challenges head-on, never shy away",
    "Protect what you love, stay true",
    "Be the best version of yourself",
    "Embrace your journey, stay strong"
];
export let brutalMotives = [
    "Do 👏 crazy 👏 stuff",
    "if it ain't brown i ain't down",
    "if there's no curry i ain't in a hurry",
    "Made her do my laundry cuz i never fold",
    "Love was in the air, so I put my mask on",
    "your favorite notification!",
    `"Crazy? I was crazy once..."`
];
export const randomStringName = (name) => {
    return motives[Math.floor(Math.random() * motives.length)].replace('{user}', name.split(' ')[0] || name);
};
export let randomString = strings[Math.floor(Math.random() * strings.length)];
export function Shuffle(array) {
    return array.sort(() => Math.random() - 0.5);
}
export function ShuffleKeys(obj) {
    let keys = Object.keys(obj);
    keys = Shuffle(keys);
    const shuffledObj = {};
    for (const key of keys) shuffledObj[key] = obj[key];
    return shuffledObj;
}
export const TypingEffect = ({ text, className }) => {
    const [displayedText, setDisplayedText] = useState('');
    const words = text.match(/\S+\s*/g);
    let i = 0;

    useEffect(() => {
        let strong = ""
        if (words.length > 0) {
            const interval = setInterval(() => {
                if (i < words.length) {
                    strong += (i > 0 ? " " : "") + words[i]
                    setDisplayedText(strong);
                    i++;
                } else {
                    clearInterval(interval);
                }
            }, Math.floor(Math.random() * 50) + 25);
            return () => clearInterval(interval);
        }
    }, [text]);

    return (
        <div className={className}>{displayedText}</div>
    );
};
export const FormatMath = ({ text, className }) => {
    const formatMath = (expr) => {
        if (expr.startsWith('\\')) return expr;
        if (isNaN(Number(expr))) return `\\(${expr?.replace(/\s*\*\s*/g, '')?.replace(/\s*\^\s*/g, '^')}\\)`;
        return Number(expr).toLocaleString();
    };

    return (
        <MathJaxContext>
            <div className={className}>
                <MathJax config={{ loader: { load: ['input/tex', 'output/svg'] }, }}>
                    {formatMath(text)}
                </MathJax>
            </div>
        </MathJaxContext>
    );
};
export const InfoPopup = memo(({ title, message, redirect, iconSrc = errorExplinationMark }) => (
    <>
        <Backdrop />
        <div className="rateLimitPopup">
            <img src={iconSrc} onClick={redirect} alt="" />
            <div className="ratelimit-content">
                <div className="ratelimit-title">{title}</div>
                <div className="ratelimit-message2">{message}</div>
                <div className="goBackPopup" onClick={redirect}>Home</div>
            </div>
        </div>
    </>
));
export const openWebsite = (hyperlink) => {
    const width = 1250, height = 650;
    const { screenLeft = window.screenX, screenTop = window.screenY } = window;
    const { innerWidth, innerHeight, screen } = window;
    const screenWidth = innerWidth || document.documentElement.clientWidth || screen.width;
    const screenHeight = innerHeight || document.documentElement.clientHeight || screen.height;
    const left = (screenWidth - width) / 2 + screenLeft;
    const top = (screenHeight - height) / 2 + screenTop;
    window.open(hyperlink, "Kasim Akr", `width=${width},height=${height},menubar=no,toolbar=no,status=no,scrollbars=yes,resizable=yes,top=${top},left=${left}`);
    return;
};
export const BannedPopup = ({ redirectHome }) => (
    <InfoPopup
        title="Account Banned"
        message="This account has been banned due to violations of our guidelines."
        redirect={redirectHome}
    />
);
export const HandleBadgeNotification = async (type) => {
    const { addNotification } = useNotification();
    const notificationContent = {
        "verified": {
            title: `Verified Badge`,
            message: "This badge shows that the account owner's identity has been confirmed by our platform",
            imageUrl: verifiedPic,
        },
        "school": {
            title: `School Account Verified`,
            message: "This badge shows that user's email has been verified to be an legitimate school account",
            imageUrl: graduationCap,
        },
        "teacherVerified": {
            title: `Teacher Account Verified`,
            message: "This user is a verified legitimate teacher",
            imageUrl: teacherVerifiedIcon,
        }
    };
    addNotification(notificationContent[type]);
};
export const gatherPreciseTime = (time) => {
    const dateObject = new Date(time);
    const now = new Date();
    let dayText = `${dateObject.getMonth() + 1}/${dateObject.getDate()}/${dateObject.getFullYear()}`;
    if (dateObject.toDateString() === now.toDateString()) dayText = "Today";
    else if (dateObject.getDate() === now.getDate() - 1) dayText = "Yesterday";
    const hours = dateObject.getHours();
    const formattedDate = `${dayText} at ${hours % 12 || 12}:${dateObject.getMinutes().toString().padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
};
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = reject;
    });
};